import http from '../https.js';


// 供应商登录
export const checkIn = (data) => {
    return http.post('/api/user/checkIn',data)
}

// 供应商退出
export const logout = (data) => {
    return http.post('/api/user/logout',data)
}

// 修改密码
export const changePassword = (data) => {
    return http.post('/api/user/changePassword',data)
}

// 城市选择(二级联动)
export const getCityList = (data) => {
    return http.post('/api/user/getCityList',data)
}

// 供应商注册申请
export const register = (data) => {
    return http.post('/api/user/register',data)
}

// 供应商经营选择
export const barnd = (data) => {
    return http.post('/api/user/barnd',data)
}

// 获取抢单品牌
export const getGrabBrand = (data) => {
    return http.post('/api/index/getGrabBrand',data)
}

// 根据品牌获取商品
export const getBrandGoods = (data) => {
    return http.post('/api/index/getBrandGoods',data)
}

// 当前筛选条件-品类去重列表
export const getCurrentCate = (data) => {
    return http.post('/api/index/getCurrentCate',data)
}

// 当前筛选条件-产品型号统计
export const getCurrentBrandSpec = (data) => {
    return http.post('/api/index/getCurrentBrandSpec',data)
}

// 当前筛选条件-地区去重列表
export const getCurrentCity = (data) => {
    return http.post('/api/index/getCurrentCity',data)
}

// 抢单任务列表
export const getTaskList = (data) => {
    return http.post('/api/index/getTaskList',data)
}

// 仓库下拉数据
export const getWarehouseList = (data) => {
    return http.post('/api/quote/getWarehouseList',data)
}

// 供应商提交报价
export const submitQuote = (data) => {
    return http.post('/api/quote/submitQuote',data)
}

// 修改报价
export const updateQuote = (data) => {
    return http.post('/api/quote/updateQuote',data)
}

// 报价修改记录
export const getQuoteLog = (data) => {
    return http.post('/api/quote/getQuoteLog',data)
}

// 出价记录
export const myQuoteList = (data) => {
    return http.post('/api/quote/myQuoteList',data)
}

// 我的订单列表
export const myOrderList = (data) => {
    return http.post('/api/quote/myOrderList',data)
}

// 查看任务全部报价
export const getTaskAllQuote = (data) => {
    return http.post('/api/quote/getTaskAllQuote',data)
}

// 确认发货
export const confirmDelivery = (data) => {
    return http.post('/api/quote/confirmDelivery',data)
}

// 下载送货单
export const downloadDelivery = (data) => {
    return http.get('/api/quote/downloadDelivery',data)
}

// 确认补货到货
export const confirmResupply = (data) => {
    return http.post('/api/quote/confirmResupply',data)
}

// 设置补交/完结
export const setResupply = (data) => {
    return http.post('/api/quote/setResupply',data)
}

// 订单详情
export const getOrderDetail = (data) => {
    return http.post('/api/quote/getOrderDetail',data)
}

// 上传盖章送货单
export const uploadStampedDelivery = (data) => {
    return http.post('/api/quote/uploadStampedDelivery',data)
}

// 上传公共
export const uploadImage = (data) => {
    return http.post('/api/quote/uploadImage', data, { name: 'file' })
}

// 撤销出价
export const cancelQuote = (data) => {
    return http.post('/api/quote/cancelQuote',data)
}

// 我的出价品牌列表
export const myQuoteBrands = (data) => {
    return http.post('/api/quote/myQuoteBrands',data)
}

// 我的出价产品型号列表
export const myQuoteSpecs = (data) => {
    return http.post('/api/quote/myQuoteSpecs',data)
}





// 会员登录
// export const login = (data) => {
//     return http.post('/api/user/login',data)
// }
// // 会员中心
// export const user = () => {
//     return http.get('/api/user/index')
// }
// 上传公共
// export const upload = (data) => {
//     return http.post('/api/common/upload', data, { name: 'file' })
// }

// 委托合同列表
export const contract_entrust_index = (data) => {
    return http.get('/api/contract_entrust/index',data)
}
// 委托合同添加
export const contract_entrust_add = (data) => {
    return http.post('/api/contract_entrust/add',data)
}
// 委托合同修改
export const contract_entrust_edit = (data) => {
    return http.post('/api/contract_entrust/edit',data)
}
// 委托合同删除
export const contract_entrust_del = (data) => {
    return http.post('/api/contract_entrust/del',data)
}
// 委托合同详情
export const contract_entrust_details = (data) => {
    return http.get('/api/contract_entrust/details',data)
}

// 检测任务单列表
export const detection_task_index = (data) => {
    return http.get('/api/detection_task/index',data)
}
// 检测任务单修改
export const detection_task_edit = (data) => {
    return http.post('/api/detection_task/edit',data)
}
// 检测任务单删除
export const detection_task_del = (data) => {
    return http.post('/api/detection_task/del',data)
}

// 卡号账户列表
export const basis_account_index = (data) => {
    return http.get('/api/basis_account/index',data)
}
// 卡号账户添加
export const basis_account_add = (data) => {
    return http.post('/api/basis_account/add',data)
}
// 卡号账户修改
export const basis_account_edit = (data) => {
    return http.post('/api/basis_account/edit',data)
}
// 卡号账户删除
export const basis_account_del = (data) => {
    return http.post('/api/basis_account/del',data)
}

// 委托单位列表
export const basis_entrust_index = (data) => {
    return http.get('/api/basis_entrust/index',data)
}
// 委托单位添加
export const basis_entrust_add = (data) => {
    return http.post('/api/basis_entrust/add',data)
}
// 委托单位修改
export const basis_entrust_edit = (data) => {
    return http.post('/api/basis_entrust/edit',data)
}
// 委托单位删除
export const basis_entrust_del = (data) => {
    return http.post('/api/basis_entrust/del',data)
}

// 检测项目详情-主要用于修改名称
export const basis_project_details = (data) => {
    return http.post('/api/basis_project/details',data)
}
// 检测项目列表
export const basis_project_index = (data) => {
    return http.get('/api/basis_project/index',data)
}
// 检测项目添加
export const basis_project_add = (data) => {
    return http.post('/api/basis_project/add',data)
}
// 检测项目修改
export const basis_project_edit = (data) => {
    return http.post('/api/basis_project/edit',data)
}
// 检测项目删除
export const basis_project_del = (data) => {
    return http.post('/api/basis_project/del',data)
}
// 检测项目添加合同列表
export const basis_project_channel = (data) => {
    return http.get('/api/basis_project/channel',data)
}

// 检测依据列表
export const basis_gist_index = (data) => {
    return http.get('/api/basis_gist/index',data)
}
// 检测依据添加
export const basis_gist_add = (data) => {
    return http.post('/api/basis_gist/add',data)
}
// 检测依据修改
export const basis_gist_edit = (data) => {
    return http.post('/api/basis_gist/edit',data)
}
// 检测依据删除
export const basis_gist_del = (data) => {
    return http.post('/api/basis_gist/del',data)
}

// 报告模板列表
export const template_index = (data) => {
    return http.get('/api/template/index',data)
}
// 报告模板添加
export const template_add = (data) => {
    return http.post('/api/template/add',data)
}
// 报告模板删除
export const template_del = (data) => {
    return http.post('/api/template/del',data)
}

// 报告存档列表
export const template_archive_index = (data) => {
    return http.get('/api/template_archive/index',data)
}
// 报告存档添加
export const template_archive_add = (data) => {
    return http.post('/api/template_archive/add',data)
}
// 报告存档删除
export const template_archive_del = (data) => {
    return http.post('/api/template_archive/del',data)
}

// 应收款列表
export const finance_index = (data) => {
    return http.get('/api/finance/index',data)
}
// 应收款删除
export const finance_del = (data) => {
    return http.post('/api/finance/del',data)
}

// 回款单列表
export const finance_returned_index = (data) => {
    return http.get('/api/finance_returned/index',data)
}
// 回款单添加
export const finance_returned_add = (data) => {
    return http.post('/api/finance_returned/add',data)
}
// 回款单删除
export const finance_returned_del = (data) => {
    return http.post('/api/finance_returned/del',data)
}


// WEBPACK FOOTER //
// ./src/api/index.js